/** @jsx jsx */
import { jsx, Box, Container, Grid } from 'theme-ui';
import { useStaticQuery, graphql } from 'gatsby';
import SectionHeading from 'components/section-heading';
import Accordion from 'components/accordion/accordion';
import Image from 'components/image';
import emoji from 'assets/images/icons/emoji-2.png';

const data = [
  {
    title: 'Organize your project content',
    contents: (
      <div>
        Get your blood tests delivered at let collect sample from the victory of
        the managements that supplies best design system guidelines ever.
      </div>
    ),
  },
  {
    title: 'Collaborate your documents easily',
    contents: (
      <div>
        Get your blood tests delivered at let collect sample from the victory of
        the managements that supplies best design system guidelines ever.
      </div>
    ),
  },
  {
    title: `Build your team's knowledge base`,
    contents: (
      <div>
        Get your blood tests delivered at let collect sample from the victory of
        the managements that supplies best design system guidelines ever.
      </div>
    ),
  },
];

const PremiumFeature = () => {
  const image = useStaticQuery(graphql`
    query {
      illustration: file(relativePath: { eq: "messenger.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <section id="features" sx={styles.section}>
      <Container>
        <Grid sx={styles.grid}>
          <Box as="figure" sx={styles.illustration}>
            <Image
              src={image.illustration.childImageSharp.fluid}
              alt="messenger"
            />
          </Box>
          <Box sx={styles.rightContent}>
            <SectionHeading
              emoji={emoji}
              sx={styles.heading}
              title="Meet our premium features that will make you wow"
              description="Build an incredible workplace and grow your business with Gusto’s all-in-one platform with amazing contents."
            />
            <Box sx={styles.accordionGroup}>
              <Accordion items={data} />
            </Box>
          </Box>
        </Grid>
      </Container>
    </section>
  );
};

export default PremiumFeature;

const styles = {
  section: {
    pt: [6, null, null, 6, 8, 9],
    pb: [6, null, null, null, 7, 9, 11, null],
  },
  grid: {
    alignItems: 'center',
    gridTemplateColumns: [
      '1fr',
      null,
      null,
      null,
      '1fr 431px',
      '1fr 530px',
      '1fr 550px',
    ],
  },
  heading: {
    textAlign: ['left', null, null, 'center', 'left'],
    ml: [null, null, null, 'auto'],
    maxWidth: [null, null, null, 520, 660],
    h2: {
      fontSize: [null, null, null, 10, 8, 40],
      img: {
        maxWidth: [24, null, null, 30, 25, null, '100%'],
        top: ['4px', '8px', null, null, '4px', '8px'],
      },
    },
    p: {
      fontSize: [null, null, null, 2],
    },
  },
  illustration: {
    mb: [-6, null, null, -8, 0],
    position: 'relative',
    zIndex: -1,
  },
  accordionGroup: {
    m: [null, null, null, '0 auto', 'unset'],
    maxWidth: [null, null, null, 600, 'none'],
  },
};
